import * as React from "react";
import { Button, Divider, Space } from "antd";
import { CardTitle } from "../../../../components/antd/card/CardTitle";
import { CardContent } from "../../../../components/antd/card/CardContent";
import { FormItemDescription } from "../../../../components/antd/form/FormItemDescription";
import { CloudAccountConfigAzureTypeOptions } from "../../utils";
import { SecretTypeTag } from "../../../../components/antd/kindselect/tagRenderers/secretTypeTag";
import { formSetValue, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpDescription } from "../../../gvc/testNewForm/CpDescription";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { CpErrorWarningArrayIcon } from "../../../gvc/testNewForm/CpErrorWarningArrayIcon";
import { CpKindSelect } from "../../../gvc/testNewForm/temp/CpKindSelect";

interface Props {}
export const ProviderAzure: React.FC<Props> = () => {
  const { id } = useCpFormContext();
  const type = useCpFormValue("azure.type");

  return (
    <>
      <CardTitle>
        Azure
        <CpErrorWarningArrayIcon names={["azure"]} />
      </CardTitle>
      <CardContent>
        <div className="mb-8">
          <div>Method</div>
          <FormItemDescription>Select the Method you want to set up Azure Cloud Account</FormItemDescription>
          <Space.Compact className="mb-6">
            {CloudAccountConfigAzureTypeOptions.map((option) => (
              <Button
                htmlType={`button`}
                type={type === option.value ? "primary" : "default"}
                onClick={() => formSetValue(id, "azure.type", option.value)}
              >
                {option.label}
              </Button>
            ))}
          </Space.Compact>
        </div>
        {type === "secret" ? null : (
          <CpFormItem>
            <CpLabel name={"azure.subscriptionId"}>Subscription ID</CpLabel>
            <CpDescription>
              <div>
                Click{" "}
                <span
                  className="cursor-pointer"
                  style={{ color: "var(--color-blue-400)" }}
                  onClick={() => {
                    formSetValue(id, "meta.drawer", "provider-azure-subscription-id");
                  }}
                >
                  here
                </span>{" "}
                to learn how to get your Azure Subscription ID.
              </div>
            </CpDescription>
            <CpInput name={"azure.subscriptionId"} style={{ maxWidth: 600 }} />
            <CpErrorWarning name={"azure.subscriptionId"} />
          </CpFormItem>
        )}
        <Divider />
        {type === "connector" ? (
          <>
            <div className="mb-4">
              <CardTitle>Create Azure Connector Secret</CardTitle>
            </div>
            <div className="mb-4">
              <FormItemDescription>
                Click{" "}
                <span
                  className="cursor-pointer"
                  style={{ color: "var(--color-blue-400)" }}
                  onClick={() => {
                    formSetValue(id, "meta.drawer", "provider-azure-function");
                  }}
                >
                  here
                </span>{" "}
                to learn how to create Azure Function.
              </FormItemDescription>
            </div>
            <CpFormItem>
              <CpLabel name={"azure.url"}>URL</CpLabel>
              <CpInput name={"azure.url"} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={"azure.url"} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={"azure.code"}>Code</CpLabel>
              <CpInput name={"azure.code"} style={{ maxWidth: 600 }} />
              <CpErrorWarning name={"azure.code"} />
            </CpFormItem>
          </>
        ) : null}
        {type === "secret" ? (
          <>
            <div className="mb-4">
              <CardTitle>Existing Azure Connector Secret</CardTitle>
            </div>
            <CpFormItem>
              <CpLabel name={"azure.secret"}>Azure Connector Secret</CpLabel>
              <CpDescription>Cannot be changed after creation (ok, my-item, item1)</CpDescription>
              <CpKindSelect
                kind="secret"
                name={"azure.secret"}
                optionValue="name"
                queries={[{ property: "type", value: "azure-connector" }]}
                tagRenderers={[SecretTypeTag] as any}
                style={{ maxWidth: 600 }}
              />
              <CpErrorWarning name={"azure.secret"} />
            </CpFormItem>
          </>
        ) : null}
      </CardContent>
    </>
  );
};
